import WelcomePage from "../../../../../content/welcome/components/WelcomePage";
import * as React from 'react';
export default {
  WelcomePage,
  React
};